const teamPopup = () => {
  const seeMoreButtons = document.querySelectorAll('.our-team .see-more');

  if(!seeMoreButtons.length) {
    return;
  }

  const teamPopup = document.querySelector('.team-popup');
  const teamPopupName = teamPopup.querySelector('.name');
  const teamPopupPosition = teamPopup.querySelector('.position');
  const teamPopupDescription = teamPopup.querySelector('.description');
  const teamPopupLink = teamPopup.querySelector('a');
  const closeButton = teamPopup.querySelector('.close');

  // Close popup function
  const closePopup = () => {
    teamPopup.classList.remove('team-popup-visible');
    setTimeout(() => {
      teamPopup.classList.remove('team-popup-shown');
    }, 510);
  };

  // Attach close event
  closeButton.addEventListener('click', closePopup);

  // Function to open popup with correct data
  const openPopupWithData = (data) => {
    teamPopupName.textContent = data.name;
    teamPopupPosition.textContent = data.position;
    teamPopupLink.href = data.url;
    teamPopupLink.textContent = data.urlText;
    teamPopupDescription.innerHTML = data.description;
    teamPopup.classList.add('team-popup-shown');
    setTimeout(() => {
      teamPopup.classList.add('team-popup-visible');
    }, 10);
  };

  // Event handler for 'See More' buttons
  seeMoreButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const box = event.target.closest('.box');
      const data = JSON.parse(box.getAttribute('data-info'));
      openPopupWithData(data);
    });
  });
};

export default teamPopup;
